export default {"src":"/_next/static/media/enterprice-icon.b739a2a7.svg","height":58,"width":58,"blurWidth":0,"blurHeight":0};